import '../../home/EsHomeHero.css';

import { esCrafterAsset, esCrafterBool, esCrafterList, esCrafterXb } from '../../../common/EsCrafter';
import { EsHeroLogo, EsHeroRow } from '../../home/EsHomeHero';

/* EsHomeHero's markup and row (EsHeroRow), its copy from a hero block. The testids are the page slug's
   (es-home-hero on the home page), the same ones EsHomeHero writes by hand, so AQA and a
   reader see one hero whichever side of switchEsCrafter they are on. The home page's title is
   the logo, as on EsHomeHero, with title_s as its spoken text; another page's hero keeps
   title_s as text. */
export default function EsBlockHero( { slug, block, item } ) {
    const aId = `es-${ slug }-hero`;

    return (
        <section id={ block.key_s } data-testid={ aId } { ...esCrafterXb( item, block ) }
                 className={ `relative z-10 overflow-hidden ${ slug === 'home' ? 'pt-[120px] pb-[14px] md:pt-[150px] xl:pt-[180px] xl:pb-[56px] 2xl:pt-[210px] 2xl:pb-[86px]' : 'pt-[120px] pb-[110px] md:pt-[150px] md:pb-[120px] xl:pt-[180px] xl:pb-[160px] 2xl:pt-[210px] 2xl:pb-[200px]' }` }>
            <EsHeroRow mini={ block.image_s ? esCrafterAsset( block.image_s, item ) : null } video={ slug === 'home' } price={ slug === 'home' }>
                { slug === 'home'
                    ? <h1 data-testid={ `${ aId }-title` } className="heroLogo col-start-2 row-start-1 mb-0 justify-start xl:justify-center" { ...esCrafterXb( item, block, 'title_s' ) }><EsHeroLogo title={ block.title_s } fluid /></h1>
                    : <h1 data-testid={ `${ aId }-title` } className="heroTitle col-start-2 row-start-1" { ...esCrafterXb( item, block, 'title_s' ) }>{ block.title_s }</h1> }
                { /* whitespace-pre-line: a newline in the blurb is a line break, so the
                     two sentences sit on two lines as EsHomeHero draws them (Tim,
                     2026-10-11). */ }
                <p data-testid={ `${ aId }-blurb` } className={ `heroBlurb col-start-2 row-start-2 ${ slug === 'home' ? 'whitespace-pre-line max-xl:@container xl:text-justify xl:[text-align-last:justify] mb-0' : 'whitespace-pre-line' }` } { ...esCrafterXb( item, block, 'blurb_t' ) }>
                    <span className="max-xl:text-[max(12px,min(1em,3.7cqw))]">{ block.blurb_t }</span>
                </p>
                <div className="heroButtons col-start-2 row-start-3 self-start flex-wrap justify-start gap-4 max-sm:gap-[2.465vw] xl:justify-between">
                    { esCrafterList( block.buttons_o ).map( ( pButton, pIndex ) => (
                        <a key={ pButton.key_s } href={ pButton.href_s }
                           data-testid={ `${ aId }-${ pButton.key_s }-button` }
                           className={ `${ esCrafterBool( pButton.primary_b ) ? 'buttonPrimary' : 'buttonSecondary' } mx-0! whitespace-nowrap px-4! md:px-8! max-sm:px-[clamp(8px,2.465vw,16px)]! max-sm:py-[clamp(8px,1.85vw,12px)]! max-sm:text-[clamp(11px,2.157vw,14px)]!` }
                           { ...esCrafterXb( item, block, 'buttons_o', pIndex ) }>
                            { pButton.label_s }
                        </a>
                    ) ) }
                </div>
            </EsHeroRow>
            <div className="absolute bottom-0 left-0 z-[-1]">
            </div>
        </section>
    );
}
